<template>
    <div v-if="show" class="space-left-bar">
        <div class="space-left-bar__track">
            <div class="space-left-bar__fill" :style="fillStyle"></div>
        </div>
        <div class="space-left-bar__label">{{label}}</div>
    </div>
</template>

<script>
export default {
    name: 'zoezi-space-left-bar',

    props: {
        space: {
            type: Number,
            default: null
        },
        spaceLeft: {
            type: Number,
            default: null
        }
    },

    computed: {
        show() {
            return this.spaceLeft !== null && this.spaceLeft !== undefined;
        },
        isFull() {
            return this.spaceLeft === 0;
        },
        fillRatio() {
            if (this.space == null || this.space <= 0) {
                return this.spaceLeft > 0 ? 1 : 0;
            }
            return Math.max(0, Math.min(1, this.spaceLeft / this.space));
        },
        fillStyle() {
            return { width: (this.fillRatio * 100) + '%' };
        },
        label() {
            if (this.isFull) return this.$translate('Fully booked');
            if (this.space != null) return this.$translate('{0} of {1} spots left').format(this.spaceLeft, this.space);
            if (this.spaceLeft === 1) return this.$translate('1 spot left');
            return this.$translate('{0} spots left').format(this.spaceLeft);
        }
    }
}
</script>

<style scoped>
.space-left-bar {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex: 1;
    min-width: 120px;
}

.space-left-bar__track {
    width: 100%;
    max-width: 210px;
    height: 6px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 3px;
    overflow: hidden;
}

.space-left-bar__fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.3s ease;
    background: linear-gradient(90deg, var(--v-primary-darken2, #1565c0) 0%, var(--v-primary-lighten3, #90caf9) 100%);
}

.space-left-bar__label {
    font-size: 0.8rem;
    color: var(--v-primary-base, #1976d2);
}
</style>
